const SELECTORS = {
    mainToggle: ":scope #main-menu-toggle",
    flyout: ":scope > ul",
    submenuToggles: ':scope [type="radio"][name$="-menu-toggle"], :scope [type="checkbox"][name$="-menu-toggle"]'
};

const CLASSES = {
    navOpen: "open",
    rootNavOpen: "nav-open",
    wasChecked: "was-checked"
};

class Navigation {
    private navigation: HTMLElement;
    private mainToggle: HTMLInputElement;
    private submenuToggles: NodeListOf<HTMLInputElement>;
    private flyout: HTMLUListElement;
    private flyoutTransitionHandler: () => void;
    private subMenuToggleHandler: () => void;

    constructor(navigation: HTMLElement) {
        this.navigation = navigation;
        this.initElements().initListener().addObserver();
        // console.log(this);
    }

    /**
     * initialize elements
     * @private
     */
    private initElements() {
        this.mainToggle = this.navigation.querySelector<HTMLInputElement>(SELECTORS.mainToggle);
        this.flyout = this.navigation.querySelector<HTMLUListElement>(SELECTORS.flyout);
        this.submenuToggles = this.navigation.querySelectorAll(
            SELECTORS.submenuToggles
        ) as NodeListOf<HTMLInputElement>;
        return this;
    }

    /**
     * initialize event listeners
     * @private
     */
    private initListener() {
        this.flyoutTransitionHandler = this.handleFlyoutTransition.bind(this);
        this.subMenuToggleHandler = this.handleSubMenuToggle.bind(this);
        return this;
    }

    /**
     * add event listeners
     * @private
     */
    private addObserver() {
        this.flyout.addEventListener("transitionend", this.flyoutTransitionHandler);
        [...this.submenuToggles].forEach((s) => s.addEventListener("click", this.subMenuToggleHandler));
        return this;
    }

    /**
     * handle flyout transitionend events
     * @private
     */
    private handleFlyoutTransition(): void {
        if (!this.mainToggle.checked) {
            /* reset menu to initial state */
            this.submenuToggles.forEach((s) => {
                const label = s.nextElementSibling;
                const parent = s.parentNode as HTMLElement;
                s.checked = parent.dataset.level === "2" && label.classList.contains("active");
                s.classList.remove(CLASSES.wasChecked);
            });
        }
        this.navigation.classList.toggle(CLASSES.navOpen, this.mainToggle.checked);
        document.querySelector(":root").classList.toggle(CLASSES.rootNavOpen, this.mainToggle.checked);
    }

    /**
     * toggle radio buttons on click
     * @param {MouseEvent} e
     * @private
     */
    private handleSubMenuToggle(e: MouseEvent) {
        const toggle = e.currentTarget as HTMLInputElement;
        if (toggle.checked) {
            [...this.navigation.querySelectorAll(`[type="radio"][name="${toggle.name}"]`)]
                .filter((t) => t !== toggle)
                .forEach((t: HTMLInputElement) => t.classList.remove(CLASSES.wasChecked));
            if (toggle.classList.contains(CLASSES.wasChecked)) {
                toggle.checked = false;
                toggle.classList.remove(CLASSES.wasChecked);
            } else {
                toggle.classList.add(CLASSES.wasChecked);
            }
        }
    }
}

const navigation = document.querySelector<HTMLElement>("body > header > nav");

if (navigation) {
    new Navigation(navigation);
}
